<template>
  <div class="audience">
    <template v-if="!loaded">
      <adx-loading-primary/>
    </template>
    <template v-else>
      <div class="audience__graph">
        <div class="audience__graph__header">
          <div class="audience__graph__header__left">
            <h6 class="large-font">{{campaignDetail.get_campaign_name}}</h6>
            <span class="small-font subtitle"> Campaign Period : {{displayPeriod(campaignDetail.get_start, campaignDetail.get_end)}}</span>
          </div>
          <div class="audience__graph__header__right">
            <!-- <button class="btn-regular secondary">Period : {{campaignDetail.get_start}} - {{campaignDetail.get_end}}</button> -->
            <v-date-picker
              v-if="campaignDetail.get_start && campaignDetail.get_end"
              mode='range'
              class="calendar-base"
              :popoverVisibility="'focus'"
              :theme-styles='themeStyles'
              popover-align="right"
              v-model='myRange'
              :show-day-popover="false"
              :min-date='convertDate(campaignDetail.get_start)'
              :max-date='convertDate(campaignDetail.get_end)'
              show-caps>
              <input
                class="calendar-base"
                type='text'
                slot-scope='{ inputValue, updateValue }'
                disabled
                :value='inputValue'
                @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
            </v-date-picker>
          </div>
        </div>
        <div class="audience__graph__card">
          <div class="card" :class="{active : !isImpression}" @click.stop="toggleReach">
            <div class="card__title small-font">
              REACH
            </div>
            <template v-if="!loading">
              <div class="card__loading">
                <adx-loading-secondary/>
              </div>
            </template>
            <template v-else>
              <div class="card__number large-title">
                {{campaignDetail.total_traffic}}
              </div>
              <!-- <div class="card__percent subhead">
                1.2%
              </div> -->
            </template>
          </div>
          <div class="card" :class="{active : isImpression}" @click.stop="toggleImpression">
            <div class="card__title small-font">
              IMPRESSION
            </div>
            <template v-if="!loading">
              <div class="card__loading">
                <adx-loading-secondary/>
              </div>
            </template>
            <template v-else>
              <div class="card__number large-title">
                {{campaignDetail.total_impression}}
              </div>
              <!-- <div class="card__percent subhead">
                1.2%
              </div> -->
            </template>
          </div>
          <div class="card">
            <div class="card__title small-font">
              FREQUENCY
            </div>
            <template v-if="!loading">
              <div class="card__loading">
                <adx-loading-secondary/>
              </div>
            </template>
            <template v-else>
              <div class="card__number large-title">
                <div class="card__number large-title" v-if="campaignDetail.total_impression != 0 && campaignDetail.total_impression != 0">{{Math.round (campaignDetail.total_impression / campaignDetail.total_traffic * 100) / 100}}</div>
                <div class="card__number large-title" v-else>0</div>
              </div>
              <!-- <div class="card__percent subhead">
                1.2%
              </div> -->
            </template>
          </div>
        </div>
        <div class="audience__graph__content">
          <adx-line-chart
            v-if="loaded"
            :chartdata="chartData"
            :options="options"/>
        </div>
      </div>
      <div class="audience__listing">
        <table>
          <thead>
            <tr>
              <th>Listing Items</th>
              <th>IMPRESSION</th>
            </tr>
          </thead>
          <tbody class="loading" v-if="!loading">
            <tr >
              <td colspan="4">
                <adx-loading-primary />
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr v-for="(listing, index) in campaignDetail.get_all_listing" :key="index">
              <td>{{listing.location_inside}} - {{listing.location_detail}}</td>
              <td>{{listing.impression}} % </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
import LineChart from '@/components/Chart/LineChart'
import LoadingPrimary from '@/components/Loading/Primary'
import LoadingSecondary from '@/components/Loading/Secondary'
import lib from '@/lib/util'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { formatShortDate, dateFormat } from '@/lib/util'
import moment from 'moment'

export default {
  name: 'adx-campaignreport-audience',
  components: {
    'adx-line-chart': LineChart,
    'adx-loading-primary': LoadingPrimary,
    'adx-loading-secondary': LoadingSecondary,
  },
  props: {

  },
  data() {
    return {
      campaignDetail: {},
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      chartData: [],
      isImpression: true,
      loaded: false,
      options: {
        responsive: true, 
        maintainAspectRatio: false, 
        legend: false
      },
      myRange: {
        start: null,
        end: null
      }
    }
  },
  computed: {

  },
  watch: {
    isImpression() {
      this.loadData()
    },
    myRange() {
      this.loadData()
    }
  },
  beforeCreate() {

  },
  async created() {
    await this.getCampaignReport()
    await this.loadData()
    
  },
  beforeMount() {

  },
  mounted() {
    
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    convertDate(value) {
      return new Date(value)
    },
    async getCampaignReport() {
      this.loading = false

      const { status, data } = await api.get(apiV2.measurementcampaignReportDetail(this.$route.params.campaign_id), { needToken: true })
      if(status == 200) {
        this.campaignDetail = await data
        this.myRange.start = new Date(data.get_start)
        this.myRange.end = new Date(data.get_end)
      }

      this.loading = true
    },
    async loadData() {
      this.loaded = false
      let params = {
          start: moment(this.myRange.start).format("YYYY-MM-DD"),
          end: moment(this.myRange.end).format("YYYY-MM-DD")
        }
      const { status, data } = await api.get(apiV2.measurementcampaignChart(this.$route.params.campaign_id), { params, needToken: true })
      if(status == 200) {
        const date = Object.keys(data).map((key, index) => {
          return formatShortDate(data[key].date)
        });

        let reach_data = 0
        let impression_data = 0
        data.map(el => {
          reach_data += el.traffic
          impression_data += el.impression
        })
        this.campaignDetail.total_impression = impression_data
        this.campaignDetail.total_traffic = reach_data
        const unique = Object.keys(data).map((key, index) => {
          if (this.isImpression) {
            return data[key].impression
          }else {
            return data[key].traffic
          }
        });

        this.chartData = {
          labels: date,
          datasets: [
            {
              backgroundColor: 'transparent',
              borderColor: '#FF2D55',
              data: unique
            }
          ]
        }
        this.loaded = true
      }
    },
    toggleReach() {
      this.isImpression = false
    },
    toggleImpression() {
      this.isImpression = true
    },
    displayPeriod(start, end) {
      let startDate = moment(start, 'YYYY-MM-DD')
      let endDate = moment(end, 'YYYY-MM-DD')
      if (startDate.year() == endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      } else if (startDate.year() < endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>